<input type="checkbox" [ngModel]="checked" (click)="onClick($event.target.checked)"/>